window.addEventListener('load', function () {

    setTimeout(function () {

        // Get all product collection URLs
        const productCollections = [];

        document.querySelectorAll(
            '#sidebar_categories .current-product-collection'
        ).forEach(link => {
            productCollections.push(
                link.getAttribute('href').replace(/\/$/, '')
            );
        });

        if (!productCollections.length) return;

        

        let currentUrl = null;
        let currentItem = null;

        // Find the first matching collection in the Globo menu
        document.querySelectorAll('.gm-links .gm-target').forEach(link => {

            const menuUrl = link
                .getAttribute('href')
                .replace(/\/$/, '');

           
            if (
                productCollections.includes(menuUrl) &&
                !link.closest('.gm-item').classList.contains('gm-heading')
            ) {
                 currentUrl = menuUrl;
                currentItem = link.closest('.gm-item');
            }
        });

        if (!currentItem) return;

        // Find the parent heading
        let heading = currentItem;

        while (
            heading &&
            !heading.classList.contains('gm-heading')
        ) {
            heading = heading.previousElementSibling;
        }

        if (!heading) return;

        // =============================
        // Build Breadcrumb
        // =============================

        let breadcrumb = '<ul class="product-breadcrumb">';
        breadcrumb += '<li><a href="/">Home</a></li>';

        // Find the top-level Globo menu item
        const gmLinks = heading.closest('.gm-links');

        if (gmLinks) {

            // Walk up until we find the parent menu item
            let parent = gmLinks.parentElement;

            while (parent && !parent.querySelector(':scope > .gm-target')) {
                parent = parent.parentElement;
            }

            const topLink = parent
                ? parent.querySelector(':scope > .gm-target')
                : null;

            if (topLink) {
                breadcrumb +=
                    '<li><a href="' +
                    topLink.getAttribute('href') +
                    '">' +
                    topLink.querySelector('.gm-text').textContent.trim().toLowerCase().replace(/\b\w/g, c => c.toUpperCase()) +
                    '</a></li>';
            }
        }

        // Parent Collection
        const headingLink = heading.querySelector('a');

        if (headingLink) {
            breadcrumb +=
                '<li><a href="' +
                headingLink.getAttribute('href') +
                '">' +
                headingLink.textContent.trim() +
                '</a></li>';
        }

        // Current Collection
        const currentLink = currentItem.querySelector('a');

        if (currentLink) {
            breadcrumb +=
                '<li class="current"><a href="' +
                currentLink.getAttribute('href') +
                '">' +
                currentLink.textContent.trim() +
                '</a></li>';
        }

        breadcrumb += '</ul>';

        document.querySelector('#product_breadcrumb').innerHTML = breadcrumb;

        let html = '<div class="sidebar-category">';
        html += '<h3>' + heading.textContent.trim() + '</h3>';
        html += '<ul class="collection-links">';

        let item = heading.nextElementSibling;

        while (item) {

            if (item.classList.contains('gm-heading')) {
                break;
            }

            const link = item.querySelector('a');

            if (link) {

                const menuUrl = link
                    .getAttribute('href')
                    .replace(/\/$/, '');
                
                    
                const active =
                    menuUrl === currentUrl
                        ? ' class="active"'
                        : '';

                html +=
                    '<li' + active + '>' +
                    link.outerHTML +
                    '</li>';
            }

            item = item.nextElementSibling;
        }

        html += '</ul></div>';

        document.querySelector('#sidebar_categories').innerHTML = html;

    }, 500);

});

// best sellers AJAX Add to Cart
document.addEventListener('click', function (e) {

    if (!e.target.classList.contains('btn-add-cart')) return;

    const variantId = e.target.dataset.variantId;
    const qtyInput = document.getElementById(
        e.target.dataset.qtyInput
    );

    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            id: variantId,
            quantity: parseInt(qtyInput.value)
        })
    })
    .then(response => response.json())
    .then(() => {
        location.reload();
    });

});
